import { Button, Modal, TextField } from "@material-ui/core";
import React, { useState } from "react";
import SaveIcon from "@material-ui/icons/Save";
import { useMutation, useQueryClient } from "react-query";
import { ReactComponent as LoadingIcon } from "../../assets/svgs/loading-icon.svg";
import { toast } from "react-toastify";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { addApp } from "../../services/app.service";

interface Props {
  open: boolean;
  handleClose: () => void;
  appCategories: any;
  appTypes: any;
}

const AddAppModal: React.FC<Props> = ({
  open,
  handleClose,
  appCategories,
  appTypes,
}) => {
  const [errTarget, setErrTarget] = useState("");
  const [appName, setAppName] = useState("");
  const [iosLink, setIosLink] = useState("");
  const [androidLink, setAndroidLink] = useState("");
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [type, setType] = useState<string | undefined>("kai app");
  const [category, setCategory] = useState<string | undefined>(
    "economic and finance"
  );

  const queryClient = useQueryClient();
  const { isLoading, mutate } = useMutation(addApp, {
    onSuccess: () => {
      queryClient.invalidateQueries("apps");
      setAppName("");
      setIosLink("");
      setAndroidLink("");
      setDescription("");
      setImageUrl("");
      setType("kai app");
      setCategory("economic and finance");
      setErrTarget("");
      handleClose();
    },
    onError: (err: any) => {
      const field = err.response.data.errorField;
      let message = "";
      if (field === "taxNo_unique") {
        message = "Tax No. has already been used !";
        setErrTarget("taxNo");
      } else if (field === "name_unique") {
        message = "Brand Name has already been used !";
        setErrTarget("name");
      }
      toast.error(`${message ? message : "Technical Fault, contact Admin !"}`, {
        autoClose: 2200,
      });
    },
  });

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    mutate({
      appName,
      iosLink,
      androidLink,
      description,
      imageUrl,
      type,
      category,
    });
  };

  return (
    <div>
      <Modal
        onClose={handleClose}
        open={open}
        className="flex justify-center items-center"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <form
            onSubmit={handleSubmit}
            style={{ width: "520px" }}
            className="bg-white rounded-md flex flex-col w-full focus:outline-none"
          >
            <div className="flex-1 bg-white w-full rounded-t-md p-5">
              <p className="text-blue-500 font-medium text-2xl">Add new App</p>
              <div className="pt-5 w-full space-y-5">
                <TextField
                  id="appName"
                  label="App Name"
                  variant="outlined"
                  className="w-full"
                  autoFocus
                  required
                  value={appName}
                  onChange={(e) => setAppName(e.target.value)}
                  error={errTarget === "name"}
                  inputProps={{ maxLength: 191 }}
                />
                <TextField
                  id="iosLink"
                  label="iOS Link"
                  variant="outlined"
                  className="w-full"
                  required
                  value={iosLink}
                  onChange={(e) => setIosLink(e.target.value)}
                  error={errTarget === "name"}
                  inputProps={{ maxLength: 191 }}
                />
                <TextField
                  id="androidLink"
                  label="Android Link"
                  variant="outlined"
                  className="w-full"
                  required
                  value={androidLink}
                  onChange={(e) => setAndroidLink(e.target.value)}
                  error={errTarget === "name"}
                  inputProps={{ maxLength: 191 }}
                />
                <TextField
                  className="w-full"
                  id="description"
                  label="Description"
                  multiline
                  rows={3}
                  variant="outlined"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  inputProps={{ maxLength: 500 }}
                />
                <TextField
                  id="imageUrl"
                  label="Image Url"
                  variant="outlined"
                  className="w-full"
                  required
                  value={imageUrl}
                  onChange={(e) => setImageUrl(e.target.value)}
                  error={errTarget === "name"}
                  inputProps={{ maxLength: 191 }}
                />
                <select
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                    // setErrBrand(false);
                  }}
                  id="type"
                  className={`py-3.5 px-3 w-full transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 capitalize form-select text-gray-600`}
                  //   className={`py-3.5 px-3 w-full transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 capitalize form-select text-gray-600 ${
                  //     errBrand && "ring ring-red-400"
                  //   }`}
                >
                  {appTypes &&
                    appTypes.map((type: any, i: number) => {
                      return (
                        <option value={type} key={i}>
                          {type}
                        </option>
                      );
                    })}
                </select>
                <select
                  value={category}
                  onChange={(e) => {
                    setCategory(e.target.value);
                    // setErrBrand(false);
                  }}
                  id="cat"
                  className={`py-3.5 px-3 w-full transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 capitalize form-select text-gray-600`}
                  //   className={`py-3.5 px-3 w-full transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 capitalize form-select text-gray-600 ${
                  //     errBrand && "ring ring-red-400"
                  //   }`}
                >
                  {appCategories &&
                    appCategories.map((cat: any, i: number) => {
                      return (
                        <option value={cat} key={i}>
                          {cat}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="h-16 w-full bg-gray-100 rounded-b-md flex justify-end space-x-4 items-center px-5">
              <Button
                onClick={handleClose}
                color="primary"
                variant="contained"
                className="focus:outline-none"
              >
                Cancel
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                variant="contained"
                color="primary"
                className="focus:outline-none"
                startIcon={<SaveIcon />}
              >
                {isLoading ? (
                  <LoadingIcon className="text-blue-600 animate-spin h-5 w-5" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </form>
        </Fade>
      </Modal>
    </div>
  );
};

export default AddAppModal;
